/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, hourStart: NonNullable<unknown>, hourEnd: NonNullable<unknown>, count: NonNullable<unknown> }} Statistics_Tooltip_RangeInputs */

const he_statistics_tooltip_range = /** @type {(inputs: Statistics_Tooltip_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ${i?.hourStart}:00-${i?.hourEnd}:00 — ${i?.count} אירועים`)
};

const en_statistics_tooltip_range = /** @type {(inputs: Statistics_Tooltip_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ${i?.hourStart}:00-${i?.hourEnd}:00 — ${i?.count} events`)
};

/**
* | output |
* | --- |
* | "{day} {hourStart}:00-{hourEnd}:00 — {count} events" |
*
* @param {Statistics_Tooltip_RangeInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_tooltip_range = /** @type {((inputs: Statistics_Tooltip_RangeInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Tooltip_RangeInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_tooltip_range(inputs)
	return en_statistics_tooltip_range(inputs)
});